import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ItemListView from 'components/items/ItemListView';
import * as itemsActions from 'store/modules/items';

class ItemListContainer extends Component {

  componentDidMount() {
    
  }

  onChangeItemSort = (e) => {
    const {id, value} = e.target;
    const {ItemsActions} = this.props;

    ItemsActions.setItemsSort({id, value});
  }

  onClickItemDtl = (itemSeq, clyn) => {
    const {ItemsActions, itemFilters} = this.props;
    const {itemKind} = itemFilters;
    const isView = 'block';

    if(itemKind !== '03' && itemKind !== '06') { //방패,코튬날개
      ItemsActions.ctrlItemDtlPopup({isView, itemSeq});
    }
  }

  render() {
    const {onChangeItemSort, onClickItemDtl} = this;
    const {loading, itemList, itemListFiltering, itemFilters} = this.props;
    
    return (
      <ItemListView 
        loading={loading}
        itemList={itemList}
        itemListFiltering={itemListFiltering}
        itemFilters={itemFilters}
        onChangeItemSort={onChangeItemSort}
        onClickItemDtl={onClickItemDtl}
      />
    );
  }
}

export default connect(
  (state) => ({
    itemFilters: state.items.toJS().itemFilters,
    itemList: state.items.getIn(['itemList','list'+state.items.toJS().itemFilters.itemKind]).toJS(),
    itemListFiltering: state.items.getIn(['itemListFiltering','list'+state.items.toJS().itemFilters.itemKind]).toJS(),
    loading: state.pender.pending['items/GET_ITEM_LIST'],
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemListContainer);